import { compose } from 'redux'

// higher-order components
import withRedux from './withRedux'
import withEventHandlers from './withEventHandlers'

// presentational component
import InfoLink from 'components/atoms/InfoLink'

export default compose(
  withRedux, // for setting modal state
  withEventHandlers // for UI interactions
)(InfoLink)
